
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../base/Button';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    // If we're not on the home page, navigate there first
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // We're already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm fixed w-full top-0 z-50">
      <nav className="px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <h1 className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/1e6b684f26e3dbcff2785a427af5447e.jpeg"
                alt="Shantonya Scott Real Estate Advisor"
                className="h-16 w-auto cursor-pointer"
                onClick={() => navigate('/')}
              />
            </h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('listings')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              Featured Listings
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              Testimonials
            </button>
            <button 
              onClick={() => scrollToSection('resources')}
              className="text-gray-700 hover:text-black transition-colors cursor-pointer"
            >
              Resources
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              variant="primary" 
              size="sm"
              className="hover:bg-yellow-500 hover:text-black hover:border-yellow-500"
            >
              Book Consultation
            </Button>
          </div>
          
          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('listings')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                Featured Listings
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                Testimonials
              </button>
              <button 
                onClick={() => scrollToSection('resources')}
                className="text-gray-700 hover:text-black transition-colors text-left cursor-pointer"
              >
                Resources
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                variant="primary" 
                size="sm" 
                className="w-full hover:bg-yellow-500 hover:text-black hover:border-yellow-500"
              >
                Book Consultation
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
